// extracted by mini-css-extract-plugin
export var header = "_fu-0";